module.exports = __webpack_public_path__ + "img/image97.48752887.png";